<template>
<div class="chapter">
<div class="inner_page">
<div class="image_container">
<img alt="images" src="images/f00vi-01.jpg"/>
<p class="captionC"><a id="page_vi"></a><em class="italic">Chris Heisey</em></p>
<p class="captionC">Fort Pulaski, Savannah, Georgia <em class="italic">Chris Heisey</em></p>
</div>
<div class="image_container">
<img alt="images" src="images/f00vi-02.jpg"/>
<p class="captionC"><a href="http://www.emergingcivilwar.com" target="_blank">www.emergingcivilwar.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Fm02.vue?44847707